import { render, staticRenderFns } from "./ImageListSettings.vue?vue&type=template&id=61502fb8&scoped=true"
import script from "./ImageListSettings.vue?vue&type=script&lang=ts"
export * from "./ImageListSettings.vue?vue&type=script&lang=ts"
import style0 from "./ImageListSettings.vue?vue&type=style&index=0&id=61502fb8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61502fb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61502fb8')) {
      api.createRecord('61502fb8', component.options)
    } else {
      api.reload('61502fb8', component.options)
    }
    module.hot.accept("./ImageListSettings.vue?vue&type=template&id=61502fb8&scoped=true", function () {
      api.rerender('61502fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/ImageListSettings.vue"
export default component.exports